import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { qsRequired } from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'

export class UgcSlider extends UcoastEl {
	static htmlSelector = 'ugc-slider'
	allSlidesLoaded = false
	constructor() {
		super()
		void this.initializeSlider()
	}

	override animateIn() {
		super.animateIn()
		void this.initializeSlider()
	}

	initializeSlider() {
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 'auto',
			align: 'center',
			containScroll: 'keepSnaps',
			dragFree: true,
			duration: 100,
			dragThreshold: 100,
		}

		const viewportNode = qsRequired('.embla__viewport', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
			AutoHeight(),
		])
		emblaApi.on('select', (event) => {
			void window.Ucoast.mediaManager.loadAllInContainer(this)
		})
		emblaApi.on('scroll', (event) => {
			void window.Ucoast.mediaManager.loadAllInContainer(this)
		})
	}
}
